import React from 'react';

const SortArrowTopIcon = (props) => (
  <svg {...props} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 11L11 1' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M1 1H11V11' stroke={props.fill} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default SortArrowTopIcon;
